"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _autoBind = _interopRequireDefault(require("auto-bind"));

var _marshaler = _interopRequireDefault(require("../util/marshaler"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var Collaborators = /*#__PURE__*/function () {
  function Collaborators(registry, _ref) {
    var parentRoutes = _ref.parentRoutes;
    (0, _classCallCheck2["default"])(this, Collaborators);
    this._api = registry;
    this._parentRoutes = parentRoutes;
    (0, _autoBind["default"])(this);
  }

  (0, _createClass2["default"])(Collaborators, [{
    key: "_getById",
    value: function () {
      var _getById2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(entityId, collaboratorId, isUser) {
        var _routeParams;

        var entityIdRoute, collaboratorIdRoute, result;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                entityIdRoute = this._parentRoutes.get;
                collaboratorIdRoute = isUser ? 'collaborator.user_ids.user_id' : 'collaborator.organization_ids.organization_id';
                _context.next = 4;
                return this._api.GetCollaborator({
                  routeParams: (_routeParams = {}, (0, _defineProperty2["default"])(_routeParams, entityIdRoute, entityId), (0, _defineProperty2["default"])(_routeParams, collaboratorIdRoute, collaboratorId), _routeParams)
                });

              case 4:
                result = _context.sent;
                return _context.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _getById(_x, _x2, _x3) {
        return _getById2.apply(this, arguments);
      }

      return _getById;
    }()
  }, {
    key: "getByUserId",
    value: function () {
      var _getByUserId = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(entityId, userId) {
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", this._getById(entityId, userId, true));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getByUserId(_x4, _x5) {
        return _getByUserId.apply(this, arguments);
      }

      return getByUserId;
    }()
  }, {
    key: "getByOrganizationId",
    value: function () {
      var _getByOrganizationId = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(entityId, organizationId) {
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", this._getById(entityId, organizationId, false));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getByOrganizationId(_x6, _x7) {
        return _getByOrganizationId.apply(this, arguments);
      }

      return getByOrganizationId;
    }()
  }, {
    key: "getAll",
    value: function () {
      var _getAll = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(entityId, params) {
        var entityIdRoute, result;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                entityIdRoute = this._parentRoutes.list;
                _context4.next = 3;
                return this._api.ListCollaborators({
                  routeParams: (0, _defineProperty2["default"])({}, entityIdRoute, entityId)
                }, params);

              case 3:
                result = _context4.sent;
                return _context4.abrupt("return", _marshaler["default"].payloadListResponse('collaborators', result));

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getAll(_x8, _x9) {
        return _getAll.apply(this, arguments);
      }

      return getAll;
    }()
  }, {
    key: "add",
    value: function () {
      var _add = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(entityId, data) {
        var entityIdRoute, result;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                entityIdRoute = this._parentRoutes.set;
                _context5.next = 3;
                return this._api.SetCollaborator({
                  routeParams: (0, _defineProperty2["default"])({}, entityIdRoute, entityId)
                }, {
                  collaborator: data
                });

              case 3:
                result = _context5.sent;
                return _context5.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function add(_x10, _x11) {
        return _add.apply(this, arguments);
      }

      return add;
    }()
  }, {
    key: "update",
    value: function () {
      var _update = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(entityId, data) {
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.add(entityId, data);

              case 2:
                return _context6.abrupt("return", _context6.sent);

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function update(_x12, _x13) {
        return _update.apply(this, arguments);
      }

      return update;
    }()
  }, {
    key: "remove",
    value: function () {
      var _remove = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(entityId, data) {
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.add(entityId, _objectSpread(_objectSpread({}, data), {}, {
                  rights: []
                }));

              case 2:
                return _context7.abrupt("return", _context7.sent);

              case 3:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function remove(_x14, _x15) {
        return _remove.apply(this, arguments);
      }

      return remove;
    }()
  }]);
  return Collaborators;
}();

var _default = Collaborators;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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